
<template>
<!-- 
    @旧版 my rewards迁移
    @Date 2022-04-26
    @Description cgc推荐页改版 - 我的奖品区域
  -->
<div class="xtc-present-reward-my">
  <div>
  <div class="reward-title">
    <span class="title">{{_('我的奖励')}}</span>
    <span class="description">{{subTitle}}</span>
  </div>
  <div class="reward-total" @click="$emit('click')">
    <div class="reward-recieved reward-block">
      <div class="amount" v-html="rewardedReward">{</div>
      <div class="description">{{_('已获得奖励')}}</div>
    </div>
    <div class="reward-pending reward-block">
      <div class="amount" v-html="pendingReward"></div>
      <div class="description">{{_('待入账奖励')}}</div>
    </div>
  </div>
  </div>
</div>
</template>

<script>
import trackEvent from '@/common/js/track'
import { getActivityType, getAmountTmpl, getIntNumFromAmount } from '@/common/js/utils'
export default {
  name: 'rewardMy',
  props: {
    info: {
      type: Object,
      default: () => ({currency: '$'})
    }
  },
  methods: {
    jumpToReward () {
      let activityType = getActivityType(this.info.businessType)
      trackEvent({
        eventId: 'sailing_c_x_invitation_reward_detail_ck',
        eventLabel: '点击奖励',
        attrs: {
          from_page: activityType || '',
          activity_id: this.info.activityID || ''
        }
      })
      this.$router.push({
        path: `/c/rewardlist?activityID=${this.info.activityID}`
      })
    },
    numfilter (amountSplit) {
      return {
        'symbol': amountSplit.symbol,
        'number': getIntNumFromAmount(amountSplit.number),
        'position': amountSplit.position,
        'display': amountSplit.display,
        'sign': amountSplit.sign
      }
    }
  },
  mounted () {
  },
  computed: {
    subTitle () {
      // 普通奖励取自
      // 阶梯奖励取自 recommendPage.currentProgress
      // const translate = '已经成功邀请了{{x}}个朋友'
      let translate = this._('FoodC_CGC_has_successfully_CrTW' /** 已经成功邀请了{{x}}个朋友 */)
      return translate.replace('{{x}}', this.info.currentProgress)
    },
    rewardedReward () {
      if (this.info.rewardedAmountSplit) {
        const splitData = {
          split: this.numfilter(this.info.rewardedAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    pendingReward () {
      if (this.info.pendingAmountSplit) {
        const splitData = {
          split: this.numfilter(this.info.pendingAmountSplit),
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.xtc-present-reward-my {
  margin: 19px 24px 0 24px;
  padding: 32px 32px 40px 32px;
  width: 638px;
  // height: 274px;
  background: #FFFFFF;
  border-radius: 12px;
}
.reward-title {
  display: flex;
  flex-direction: column;
  .title {
    // width: 193px;
    height: 36px;
    // font-family: DiDiSansPro-Medium;
    font-family: Aspira Medium;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
    font-weight: 500;
  }
  .description {
    margin-top: 12px;
    width: 638px;
    height: 28px;
    // font-family: DiDiSansPro-Regular;
    font-family: 'Aspira Regular';
    font-size: 28px;
    color: #666666;
    letter-spacing: 1px;
    line-height: 28px;
    font-weight: 400;
  }
}
.reward-total {
    padding-top 42px
    // height 48px
    width 100%
    display flex
    align-items center
    justify-content space-between
    .reward-block {
      flex auto 
      width 50%
      padding 6px 0
      display flex
      flex-direction column
      align-items center
      justify-content center
      flex-wrap nowrap
      .amount {
        font-family 'Aspira Medium'
        font-size 40px
        color #000000
        line-height 36px
      }
      .description {
        margin-top 12px
        font-family 'Aspira Light'
        font-size 24px
        color #000000
      }
    }
    .reward-recieved {
      border-right: 1px solid rgba(0,0,0,0.1);
    }
}
</style>